export const replaceQuoteSigns = (data) => {
  var _a;
  return (_a = data == null ? void 0 : data.replace(/&quot;/g, '"')) == null ? void 0 : _a.replace(/&apos;/g, "'");
};
